import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const images = [
  "/Carousel/chikki-shop.jpg",
  "/Carousel/chips-shop.jpg",
  "/Carousel/namkeen-shop.jpg",
  "/Carousel/puffs-and-rings-shop.jpg",
  "/Carousel/snacks-shop.jpg",
];

const LoginCarousel = () => {
  return (
    <div className="login-carousel-container" style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <Carousel
        showThumbs={false}
        showArrows={false}
        showStatus={false}
        autoPlay
        infiniteLoop
        interval={3000}
        transitionTime={600}
        emulateTouch>
        {images.map((image, index) => (
          <div key={index}>
            <img src={image} alt={`Image ${index}`} />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default LoginCarousel;
